import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal, Form, Button } from 'antd';
import { CloseIcon } from '../../assets/icons';
import OTPInput from '../OTPInput';
import { verifyPin } from '../../services/AccountApi/profileApi';
import { toastNotify } from '../../utils/toastNotify';
import './PinModal.scss';
import { removeCookie } from '../../utils/cookies';

const PinModal = (props) => {
  const [pin, setPin] = useState(undefined);
  const [loading, setLoading] = useState(undefined);
  const [countDown, setCountDown] = useState(0);
  const [seconds, setSeconds] = useState(300);
  const [wrongPinCount, setWrongPinCount] = useState(0);
  const [disabledPinInput, setDisabledPinInput] = useState(false);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  let intervalId;
  let timer;
  let navigate = useNavigate();

  const timerCounter = (timerValue = 30) => {
    let timeleft = timerValue;
    timer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(timer);
        setDisabledPinInput(false);
        localStorage.setItem('wrongOtpCount', 3);
        setCountDown(0);
      } else {
        if (timeleft < 10) {
          timeleft = 0 + '' + timeleft;
        }
        setCountDown(timeleft);
      }
      timeleft -= 1;
    }, 1000);
  }

  const fiveMinTimeCounter = () => {
    intervalId = setInterval(() => {
      //   setDisabledCheckbox(true);
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          setWrongPinCount(4);
          localStorage.setItem('wrongOtpCount', 4);
          setDisabledPinInput(false);
          //   setDisabledCheckbox(false);
          clearInterval(intervalId); // Stop the timer when it reaches zero
          // You can add additional logic here when the countdown reaches zero
        }
        return prevSeconds - 1;
      });
    }, 1000);
  }

  const handleVerifyPin = async () => {
    setLoading(true);
    let formData = {
      pin: pin,
      pinVerificationType: 'profileEdit',
    };
    try {
      const response = await verifyPin(formData);
      if (!response.isError) {
        props.clickAction();
        localStorage.removeItem('wrongOtpCount');
        setWrongPinCount(0);
        setPin(undefined);
      } else {
        if(response?.data?.data?.loginRetryAttempt === 1){
          localStorage.setItem('wrongOtpCount',0)
      }
      if(response?.data?.data?.loginRetryAttempt === 2){
          localStorage.setItem('wrongOtpCount',1)
      }
        if (response?.data?.data?.loginRetryAttempt === 3) {
          localStorage.setItem('wrongOtpCount', 2);
          setDisabledPinInput(true);
          timerCounter();
          localStorage.setItem('pinRetriesTimeCounter', new Date().getTime())
        }
        if (response?.data?.data?.loginRetryAttempt === 4) {
          localStorage.setItem('wrongOtpCount', 4)
          setDisabledPinInput(true);
          fiveMinTimeCounter();
          localStorage.setItem('pinRetriesTimeCounter', new Date().getTime())
        }
        if (response?.data?.data?.loginRetryAttempt === 5) {
          localStorage.clear();
          removeCookie();
          window.location.href = '/login'
        }
        toastNotify('error', response?.data?.message);
        setPin(undefined);
      }
    } catch (error) {
      const { response } = error;
      if(response?.data?.data?.loginRetryAttempt === 1){
        localStorage.setItem('wrongOtpCount',0)
    }
    if(response?.data?.data?.loginRetryAttempt === 2){
        localStorage.setItem('wrongOtpCount',1)
    }
      if (response?.data?.data?.loginRetryAttempt === 3) {
        localStorage.setItem('wrongOtpCount', 2);
        setDisabledPinInput(true);
        timerCounter();
        localStorage.setItem('pinRetriesTimeCounter', new Date().getTime())
      }
      if (response?.data?.data?.loginRetryAttempt === 4) {
        localStorage.setItem('wrongOtpCount', 4)
        setDisabledPinInput(true);
        fiveMinTimeCounter();
        localStorage.setItem('pinRetriesTimeCounter', new Date().getTime())
      }
      if (response?.data?.data?.loginRetryAttempt === 5) {
        localStorage.clear();
        removeCookie();
        window.location.href = '/login'
      }
      toastNotify('error', response?.data?.message);
      setPin(undefined);
    } finally {
      setLoading(false);
    }
    // props.clickAction
  };
  useEffect(() => {
    clearInterval(intervalId);
    if (localStorage.getItem('wrongOtpCount') === '2') {
        const currentTime = new Date().getTime();
        const tabClosingTime = localStorage.getItem('pinRetriesTimeCounter');
        if (tabClosingTime) {
            const differenceInSeconds = (currentTime - parseInt(tabClosingTime)) / 1000;
            if (differenceInSeconds < 30) {
                setDisabledPinInput(true);
                timerCounter(30 - parseInt(differenceInSeconds));
            }
        } else {
            setDisabledPinInput(true);
            timerCounter();
        }
    }
    if (localStorage.getItem('wrongOtpCount') === '3') {
        setWrongPinCount(3);
    }
    if (localStorage.getItem('wrongOtpCount') === '4') {
        const currentTime = new Date().getTime();
        const tabClosingTime = localStorage.getItem('pinRetriesTimeCounter');
        if (tabClosingTime) {
            const differenceInSeconds = (currentTime - parseInt(tabClosingTime)) / 1000;
            if (differenceInSeconds < 300) {
                setSeconds(300 - parseInt(differenceInSeconds))
                setDisabledPinInput(true);
                setWrongPinCount(3);
                fiveMinTimeCounter();
            }
        } else {
            setWrongPinCount(3);
            fiveMinTimeCounter();
            setDisabledPinInput(true);
        }
    }
    if (localStorage.getItem('wrongOtpCount') === '4') {
        setWrongPinCount(4);
    }
    return () => {
        clearInterval(timer);
    }
}, [])
  return (
    <Modal
      className='pinmodal'
      open={props.setOpen}
      onCancel={() => {
        props.setClose();
        setPin(undefined);
      }}
      closeIcon={<CloseIcon />}
      footer={false}
      width={524}
      centered
    >
      <h4 className='mb-40 text-center pinmodal__title'>Enter your 4-digit PIN</h4>
      <Form
        className='signup-form pin-form'
        onKeyPress={(e) => {
          if (pin?.length === 4 && e.key === 'Enter') {
            handleVerifyPin();
          }
        }}
      >
        <OTPInput
          length={4}
          onChangeOTP={(otp) => setPin(otp)}
          onClearOtp={pin}
          otp={pin}
          disabled={loading || disabledPinInput}
          className='mb-48 otp'
          autoFocus
          inputClassName='otp__input'
        />
        {props.children && props.children}
        {countDown > 0 && <div className='mb-10 fw-500 text-center'>You can retry after {countDown} seconds</div>}
        {seconds < 300 && seconds > 0 && (
          <div className='mb-10 fw-500 text-center'>
            You can retry after {minutes > 0 && `${minutes} minutes `}
            {remainingSeconds < 60
              ? `${remainingSeconds} seconds`
              : `${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds} seconds`}
          </div>
        )}
        <Form.Item className='mb-0'>
          <Button type='primary' className='w-100' loading={loading} onClick={handleVerifyPin} disabled={!pin || pin?.length < 4 || disabledPinInput}>
            Confirm
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PinModal;
